<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Rematrícula</h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <h3 class="tituloForm" v-if="showForm">Pesquisar Aluno</h3>
        <vs-row vs-w="12" v-if="showForm">
          <vs-col vs-lg="8" vs-xs="12">
            <vs-input
              name="ra"
              type="number"
              v-model="ra"
              placeholder="Digite o RA do Aluno"
              @keyup.enter="searchRA(ra)"
            />
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12">
            <vs-button icon="search" style="width: 100%;" @click="searchRA(ra)" :disabled="!ra.length">
              Pesquisar
            </vs-button>
          </vs-col>
          <vs-divider/>
          <vs-row style="margin-top: 10px;" v-for="course in coursesList" :key="course.IDHABILITACAOFILIAL">
            <vs-card style="box-shadow: 0px 0px 2px 1px #888888;" v-if="course.RA != null">
              <div slot="header">
                <h4>{{ course.CURSO }}</h4>
              </div>
              <div v-if="course.CODATENDIMENTO != 0">
                <p>
                  <strong> Código de Atendimento (Protocolo): </strong>
                  {{ course.CODATENDIMENTO }}
                </p>
              </div>
              <div>
                <p><strong> Aluno: </strong>
                  {{ course.ALUNO }}
                </p>
                <p>
                  <strong> Data Mínima para Rematrícula: </strong>
                  {{ course.DATAMINREM }}
                </p>
                <p>
                  <strong> Polo/Filial Atual: </strong>
                  {{ course.FILAILPOLO }}
                </p>
                <p>
                  <strong> Situação de Matrícula Atual: </strong>
                  {{ course.STATUS }}
                </p>
                <p>
                  <strong> Matriz Curricular: </strong>
                  {{ course.MATRIZ }}
                </p>
                <vs-button
                  style="width: 100%; margin: 15px 0 10px 0;"
                  icon="local_offer"
                  @click="selectCourse(course)"
                >
                  Ver Ofertas
                </vs-button>
              </div>
            </vs-card>
          </vs-row>
          <vs-row>
            <vs-col>
              <vs-alert
                title="Erro ao buscar cursos para rematrícula"
                class="margin"
                color="danger"
                v-if="error"
              >
                {{ error }}
              </vs-alert>
              <vs-alert
                title="Erro ao buscar cursos para rematrícula"
                class="margin"
                color="danger"
                v-if="noData"
              >
                Não foram encontrados cursos para rematrícula para o RA informado:
                {{ this.ra }}
              </vs-alert>
            </vs-col>
          </vs-row>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import Person from "../services/person";
import moment from "moment";
import { getLoginDataFromStorage, updateStepsInformation } from "../helpers";

export default {
  name: "ReEnrollment",
  data: () => ({
    ra: "",
    coursesList: [],
    error: null,
    showForm: true,
    noData: false,
  }),

  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },
  mounted() {
    const loginData = getLoginDataFromStorage();
    if (loginData.RA) {
      this.ra = loginData.RA;
      this.showForm = false;
      this.searchRA(this.ra);
    }
  },
  methods: {
    selectCourse(course) {
      let reEnrollment = true;
      updateStepsInformation({ course, reEnrollment });
      this.$router.push("/offersreenrollment");
    },
    searchRA(ra) {
      this.$vs.loading({
        color: "danger",
      });
      this.noData = false;
      new Person()
        .getCoursesByRA(ra)
        .then(({ data }) => {
          this.coursesList = Array.isArray(data) ? data : [data];
          if (this.coursesList[0] == "") this.noData = true;
        })
        .catch(({ response }) => {
          console.log("Erro da busca do aluno: " + response.data.error);
          this.error =
            "O sistema não conseguiu localizar cursos em situação de rematrícula para este aluno. Verifique se já não existe uma rematrícula lançada.";
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style>
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
</style>
